module.exports = __webpack_public_path__ + "img/copilot.be367652.gif";